<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="500px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ showTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <el-text-field
          required
          label="Akto DVS numeris"
          v-model="formData.dvs_number"
          :maxlength="20"
        />
        <el-date-picker
          required
          label="DVS registracijos data"
          v-model="formData.dvs_date"
        />
        <el-checkbox
          required
          class="mt-0"
          label="Patvirtinu, kad duomenų naikinimo aktas yra pasirašytas"
          v-model="formData.read_understood"
        />
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <template>
          <el-button
            title="Atšaukti"
            :loading="loading"
            @click.native.stop="closeModal()"
            color="secondary"
          />
          <el-button
            title="Išsaugoti"
            :loading="loading"
            @click.native="confirmData()"
            color="primary"
          />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalInputDVS',
  props: {
    value: Boolean,
    item: Object,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      formData: {
        read_understood: false,
      },
      loading: false,
    }
  },
  computed: {
    showTitle() {
      return this.$t('Įvesti DVS duomenis')
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
    },
    confirmData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.saveData()
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    saveData() {
      this.loading = true
      let formData = this.formData
      formData.id = this.item.id
      this.$axios
        .post(`destruction-acts/${this.item.id}`, formData)
        .then(() => {
          this.$emit('listUpdate')
          this.closeModal()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
